import {
  Exclude, Expose, Transform, Type
} from 'class-transformer';
import { getPedigreeTypeLabel } from './animal-utils';
import { PedigreeType } from './pedigree-type.enum';

@Exclude()
export class Pedigree {
  @Expose()
  @Type(() => Pedigree)
  children: Pedigree[];

  @Expose()
  animalId: string;

  @Expose()
  studId: string;

  @Expose()
  type: PedigreeType;

  @Expose()
  @Transform((value, obj) => getPedigreeTypeLabel(obj.type))
  typeLabel: string;

  @Expose()
  isLinked: boolean;
}
